













import { defineComponent, PropType, toRefs, computed } from '@vue/composition-api';
import backupImg from '@/components/common/back-img/index.vue';
import { i18n } from './../../../../i18n';
import { CampaignFormData } from '@tt4b/ttam-enums';
import { useStdCampaignIs } from '@tt4b/ttam-hooks';

const name = 'ttam-product-details-from';
export default defineComponent({
  name,
  components: {
    backupImg,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    assetIcon: {
      type: String,
      default: '',
    },
    assetName: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { campaignData } = toRefs(props);
    const { isLeadAdsAutoInventoryAds } = useStdCampaignIs({
      campaignFormData: campaignData,
    });

    const text = computed(() =>
      isLeadAdsAutoInventoryAds.value
        ? i18n.t('module_aia_product_selected_details_desc')
        : i18n.t('module_product_selected_details_desc'),
    );

    return {
      name,
      text,
    };
  },
});
